import { render, staticRenderFns } from "./add-electronic-express-waybill.vue?vue&type=template&id=871e7206&scoped=true"
import script from "./add-electronic-express-waybill.ts?vue&type=script&lang=ts&external"
export * from "./add-electronic-express-waybill.ts?vue&type=script&lang=ts&external"
import style0 from "./add-electronic-express-waybill.scoped.scss?vue&type=style&index=0&id=871e7206&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e7206",
  null
  
)

export default component.exports